module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-rahmen-03.1cc8816f.jpeg";